import { Tooltip } from '@radix-ui/themes';

export default Tooltip;
